module.exports = __webpack_public_path__ + "a8d004adf6da60665c0862e8b6d7dd42.png";